import { useRef, useLayoutEffect } from "react";
import style from "./style.module.scss";

export default function InputTextArea(props) {
  const { required, value } = props;

  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;

    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  };

  useLayoutEffect(() => {
    resize();
  }, [value]);

  return (
    <textarea
      onInput={resize}
      style={{ resize: "none", overflow: "hidden" }}
      ref={ref}
      rows={1}
      data-required={required}
      data-required-valid={required && !!value}
      className={style.textarea}
      value={value}
      {...props}
    />
  );
}
